export default __webpack_public_path__ + "static/media/stonefloor.6c4d53d2.png";